import { render } from "./HeaderSearchDesktop.vue?vue&type=template&id=4989c21f&scoped=true"
import script from "./HeaderSearchDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderSearchDesktop.vue?vue&type=script&lang=js"

import "./HeaderSearchDesktop.vue?vue&type=style&index=0&id=4989c21f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4989c21f"

export default script